//tslint:disable:export-name
import { Container } from 'hypo-container';
import { ProductUgcService } from './ProductUgcService';
import { ConfigStore } from './ConfigStore';
import { Config } from '../internal/domain/entities/Config';
import { ConfigRepository } from '../internal/repositories/ConfigRepository';
import { OlapicWidgetViewController } from '../internal/controllers/OlapicWidgetViewController';
import { getDecorators } from 'elc-service';

export const diContainer = new Container();
export const serviceNames = {
    productUgcService: 'PRODUCT_UGC_SERVICE',
    configStore: 'CONFIG_STORE',
    config: 'CONFIG',
    configRepository: 'CONFIG_REPOSITORY',
    olapicWidgetViewController: 'OLAPIC_WIDGET_VIEW_CONTROLLER'
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setConfig = (configJSON: any) => {
    diContainer.config = configJSON;
};

diContainer
    .register(
        serviceNames.configStore,
        diContainer.factory(c => new ConfigStore(c.config))
    )
    .register(serviceNames.config, c => new Config())
    .register(serviceNames.productUgcService, c => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new ProductUgcService((config: any) => {
            setConfig(config);

            return;
        });
    })
    .register(serviceNames.configRepository, () => new ConfigRepository())
    .register(
        serviceNames.olapicWidgetViewController,
        diContainer.factory(c => new OlapicWidgetViewController(c.get(serviceNames.config)))
    );

const { lazyInject } = getDecorators(diContainer);

export { lazyInject };
